import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import SpecialMenuLayout from "@/components/menu-management/special-menu/special-menu-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import PartyTabs from "./tabs/party-tabs";
import DraftList from "./tabs/draft-list";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SpecialMenuSkeleton from "@/components/skeleton/special-menu-skeleton";
import useAuth from "@/hooks/useAuth";

import {
  fetchAllPartyPlatters,
  clearPartyPlatterMessages,
} from "@/redux/slice/menu-manage-slice/special-menu/party-platters-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";

function Party() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.party);

  useEffect(() => {
    dispatch(fetchAllPartyPlatters(user.restaurant_id));
    dispatch(clearPartyPlatterMessages());
    dispatch(clearItemVariants());
  }, [user.restaurant_id]);

  if (getLoading) return <SpecialMenuSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <SpecialMenuLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs valueKey="special-menu-party" className="bg-transparent w-full relative" defaultValue="day">
            <Separator className="absolute top-8" />
            <TabsList className="w-[300px]">
              <TabsTrigger className="bg-transparent" value="day">
                Party/Occasion Platter Sample
              </TabsTrigger>
              <TabsTrigger value="draft">Draft List</TabsTrigger>
            </TabsList>
            <PartyTabs />
            <DraftList />
          </Tabs>
        </Card>
      </SpecialMenuLayout>
    </Layout2>
  );
}

export default Party;
